<app-resource-details-info
    [resource]="resource"
    [user]="user"
    [customer]="customer"
    [resourceItems]="resourceItems"
    [resourceCategories$]="resourceCategories$"
    [resourceTags$]="resourceTags$"
    [resourceType]="ResourceTypes.parentType(resource.type_id)"
    [resourceActionBtn]="resource.playableResource$ | async"
    resourceLabel="Material"
    i18n-resourceLabel
>
    <ng-container itemsHeader></ng-container>
    <span managerLabel i18n="@@author">Author</span>
    <ng-container resourceItemsSection></ng-container>
    <span actionBtnLabel i18n="@@start">Start</span>
    <span resCodeLabel i18n>Material code</span>
    <ng-container resourceDates></ng-container>
    <ng-container resourceCircles>
        <div class="circle-item" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px">
            <div class="icon-wrapper">
                <mat-icon matListIcon fontSet="klickdata" fontIcon="kd-icon-document"></mat-icon>
            </div>
            <span>{{ resource | resourceDefaultNameDisplay : false | async }}</span>
        </div>
    </ng-container>
</app-resource-details-info>
